<template>
	<div style="overflow: auto;height: 100%;margin-left: 0px;margin-right: 0px;">
		<!-- 模板内容不变 -->
		<div style="margin-bottom: 22px;display: flex;align-items: center;padding:0 16px;">
			<div style="flex: 1;display: flex;align-items: center;">
				<div style="font-size: 14px;color: #0F1A3A;  opacity: 0.5;">{{ $t('driver.驾驶评分统计') }}</div>
				<img :src="require('@/assets/images/ic_arrow_right.png')" style="width: 24px;height: 24px;" />
				<div style="font-size: 14px;color: #0F1A3A;">{{ $t('driver.驾驶评分统计详情') }}</div>
			</div>
			<el-button type="primary" @click="onClose" size="small">{{ $t('driver.返回') }}</el-button>
		</div>
		<el-row :gutter="20" style="margin-left:0;margin-right: 0;">
			<el-col :span="7">
				<div
					style="border: 1px solid #D9E4F8;background: #FFFFFF;border-radius: 2px;display: flex;flex-direction: column;">
					<!-- 原有标题和total组件 -->
					<div style="padding: 20px;font-size: 14px;font-weight: bold;color: #0E193B;">{{ carNo }}</div>
					<mileage_item_total :score="totalScore" :mileage="totalMileage" :time="totalTime" />

					<!-- 列表区域（限制高度+滚动） -->
					<div style="flex: 1;overflow-y: auto;padding: 0 16px;">
						<div v-for="(item, idx) in currentPageData" :key="idx">
							<mileage_item_info :score="item.Score" :mileage="item.Mileage"
								:time="formatTime(item.BeginTime) + ' - ' + formatTime(item.EndTime)"
								:selected="isItemSelected(item)"
								@click="handleItemClick(item)" />
						</div>
						<div v-if="dataTypes.length === 0" style="text-align: center;padding: 20px;color: #999;">
							{{ $t('public.noData') }}
						</div>
					</div>

					<!-- 分页区域（独立容器，强制宽度100%） -->
					<div class="pagination-wrapper">
						<!-- <div>共{{dataTypes.length}}条</div> -->
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
							:current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize"
							layout="prev, pager, next" :total="dataTypes.length" size="small" />
					</div>
				</div>
			</el-col>
			<el-col :span="17">
				<div style="background: #FFFFFF;border-radius: 2px;border: 1px solid #D9E4F8;">
					<!-- 使用v-if确保组件完全重新渲染 -->
					<template v-if="showMileageInfo">
						<mileage_info :key="`mileage-info-${mileageInfoKey}`" :traceData="localTraceData"
							:drivingScore="localDrivingScore" :drivingdata="localDrivingdata" />
					</template>

					<!-- 使用v-if确保组件完全重新渲染 -->
					<template v-if="showScoreItemList">
						<score_item_list style="margin:16px;" :drivingScore="filteredDrivingScore"
							:key="`score-list-${scoreItemListKey}`" />
					</template>

					<div style="width: 100%;height: 400px;">
						<KingLongMap v-if="showMap" ref="klmap" :coordsType="9" @map-ready="onMapReady" />
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>
<script>
import mileage_info from "./components/mileage_info"
import score_item_list from "./components/score_item_list"
import mileage_item_info from "./components/mileage_item_info"
import mileage_item_total from "./components/mileage_item_total"
import {
	mapState
} from 'vuex';
import KingLongMap from "@/components/KingLongMap";

export default {
	props: {
		carNo: String,
		dataTypes: {
			type: Array,
			default: () => []
		},
		totalMileage: Number,
		totalScore: Number,
		totalTime: String,
		traceData: {
			type: Array,
			default: () => []
		},
		drivingScore: {
			type: Array,
			default: () => []
		},
		drivingdata: {
			type: Object,
			default: () => ({
				Consume: 0.0,
				Duration: 0.0,
				Speed: 0.0,
				Mileage: 0.0
			})
		}
	},
	components: {
		mileage_info,
		score_item_list,
		mileage_item_info,
		KingLongMap,
		mileage_item_total
	},
	data() {
		return {
			GpsData: [],
			dataTypesTemp: this.dataTypes,
			loading: false,
			hasDefaultClicked: false, // 标记是否已执行过默认点击
			localTraceData: Array.isArray(this.traceData) ? [...this.traceData] : [],
			localDrivingScore: Array.isArray(this.drivingScore) ? [...this.drivingScore] : [],
			localDrivingdata: {
				...this.drivingdata
			},
			currentPage: 1, // 当前页码
			pageSize: 10, // 每页条数（默认10条）
			pageSizes: [10, 20],
			mapReady: false, // 地图是否准备就绪
			showMap: true, // 控制地图组件的显示
			mapInitRetryCount: 0, // 地图初始化重试计数
			mapInitMaxRetries: 20, // 最大重试次数
			pendingItemClick: null, // 待处理的项目点击
			pendingGpsData: null, // 待处理的轨迹数据
			mileageInfoKey: 0, // 用于强制重新渲染mileage_info组件的key
			scoreItemListKey: 0, // 用于强制重新渲染score_item_list组件的key
			previousCarNo: '', // 记录上一次的车辆号
			firstLoad: true, // 标记是否是第一次加载
			itemClickInProgress: false, // 标记是否正在进行项目点击
			showMileageInfo: true, // 控制mileage_info显示
			showScoreItemList: true, // 控制score_item_list显示
			currentItemId: null, // 当前选中的项目ID
			// 默认的空数据模板
			emptyDrivingData: {
				Consume: 0.0,
				Duration: 0.0,
				Speed: 0.0,
				Mileage: 0.0
			}
		}
	},
	computed: {
		...mapState({
			operator: state => state.user.operator,
			vehicles: state => state.app.vehicles,
		}),
		currentPageData() {
			const start = (this.currentPage - 1) * this.pageSize;
			const end = start + this.pageSize;
			return this.dataTypes.slice(start, end);
		},
		// 处理驾驶评分数据，确保是有效的数组
		filteredDrivingScore() {
			if (!Array.isArray(this.localDrivingScore)) {
				return [];
			}
			// 过滤掉无效的数据
			return this.localDrivingScore.filter(item => item && typeof item === 'object');
		}
	},
	watch: {
		// 监听 dataTypes 变化（数据就绪触发）
		dataTypes: {
			handler(newVal, oldVal) {
				console.log('dataTypes变化: 新长度=', newVal ? newVal.length : 0, '旧长度=', oldVal ? oldVal.length : 0);

				// 如果切换车辆后dataTypes变化，重置所有数据
				if (this.previousCarNo !== this.carNo) {
					console.log('检测到车辆切换，重置数据');
					this.resetAllData();
					this.previousCarNo = this.carNo;
				}

				// 数据有效 + 未触发过默认点击 → 执行
				if (newVal && newVal.length > 0 && !this.hasDefaultClicked && !this.itemClickInProgress) {
					console.log('有数据但未触发默认点击，开始尝试触发');
					this.tryDefaultClick();
				}
			},
			deep: true,
			immediate: true
		},
		// 单独监听 props 变化（同步到本地数据）
		traceData(newVal) {
			this.localTraceData = Array.isArray(newVal) ? [...newVal] : [];
		},
		drivingScore(newVal) {
			this.localDrivingScore = Array.isArray(newVal) ? [...newVal] : [];
		},
		drivingdata(newVal) {
			this.localDrivingdata = {
				...newVal
			};
		},
		// 监听地图就绪状态
		mapReady(newVal) {
			if (newVal) {
				console.log('地图已就绪，尝试执行待处理的操作');
				// 执行待处理的项目点击
				this.executePendingItemClick();
				// 绘制待处理的轨迹
				this.drawPendingGpsData();
			}
		},
		// 监听 carNo 变化（切换车辆时重置并重新触发）
		carNo(newCarNo, oldCarNo) {
			if (newCarNo && newCarNo !== oldCarNo) {
				console.log('切换车辆，从', oldCarNo, '到', newCarNo, '重置所有状态');

				// 重置所有状态和数据
				this.resetAllData(true); // 传递true表示是车辆切换

				// 记录新的车辆号
				this.previousCarNo = newCarNo;

				// 延迟确保 dataTypes 同步更新后触发
				setTimeout(() => {
					this.tryDefaultClick();
				}, 300);
			}
		}
	},
	methods: {
		onClose() {
			// 离开前清空数据
			this.resetAllData();
			this.$emit('onClose');
		},

		// 重置所有状态和数据
		resetAllData(isVehicleChange = false) {
			console.log('重置所有数据，是否是车辆切换:', isVehicleChange);

			// 重置数据
			this.localTraceData = [];
			this.localDrivingScore = [];
			this.localDrivingdata = { ...this.emptyDrivingData };
			this.GpsData = [];
			this.pendingGpsData = null;

			// 重置状态
			this.hasDefaultClicked = false;
			this.mapInitRetryCount = 0;
			this.pendingItemClick = null;
			this.currentPage = 1;
			this.itemClickInProgress = false;
			this.currentItemId = null;

			// 如果是车辆切换，强制重新渲染所有组件
			if (isVehicleChange) {
				console.log('车辆切换，强制重新渲染组件');

				// 先隐藏组件
				this.showMileageInfo = false;
				this.showScoreItemList = false;

				// 在下一次DOM更新后显示组件
				this.$nextTick(() => {
					// 递增key
					this.mileageInfoKey += 1;
					this.scoreItemListKey += 1;

					// 重新显示组件
					setTimeout(() => {
						this.showMileageInfo = true;
						this.showScoreItemList = true;
						console.log('组件已重新渲染');
					}, 50);
				});
			} else {
				// 非车辆切换，只递增key
				this.mileageInfoKey += 1;
				this.scoreItemListKey += 1;
			}

			// 重置地图状态
			this.mapReady = false;

			// 重新挂载地图组件
			this.remountMap();
		},

		// 重新挂载地图组件
		remountMap() {
			console.log('重新挂载地图组件');
			this.showMap = false;
			this.$nextTick(() => {
				setTimeout(() => {
					this.showMap = true;
					console.log('地图组件已重新挂载');
				}, 50);
			});
		},

		// 清空地图轨迹
		clearMapTrack() {
			if (this.$refs.klmap) {
				try {
					if (this.$refs.klmap.clearOverlay) {
						this.$refs.klmap.clearOverlay('gps_line');
						console.log('已清除地图轨迹');
					}
					// 清除所有覆盖物
					if (this.$refs.klmap.clearAllOverlays) {
						this.$refs.klmap.clearAllOverlays();
					}
				} catch (error) {
					console.error('清除地图轨迹失败:', error);
				}
			}
		},

		// 尝试触发默认点击
		tryDefaultClick() {
			console.log('tryDefaultClick 调用', {
				dataTypesLength: this.dataTypes ? this.dataTypes.length : 0,
				hasDefaultClicked: this.hasDefaultClicked,
				mapReady: this.mapReady,
				firstLoad: this.firstLoad
			});

			// 检查所有条件是否满足
			if (this.dataTypes &&
				this.dataTypes.length > 0 &&
				!this.hasDefaultClicked &&
				!this.itemClickInProgress) {

				// 如果地图已准备就绪，直接触发
				if (this.mapReady) {
					console.log('地图已就绪，触发默认点击第一个项');
					// 确保是第一次加载时才重置
					if (this.firstLoad) {
						this.firstLoad = false;
						this.handleItemClick(this.dataTypes[0]);
						this.hasDefaultClicked = true;
					}
				} else {
					console.log('地图未就绪，等待地图就绪后再触发');
					// 将默认点击标记为待处理
					this.pendingItemClick = this.dataTypes[0];

					// 启动地图检查
					this.startMapCheck();
				}
			}
		},

		// 启动地图检查
		startMapCheck() {
			if (this.mapInitRetryCount < this.mapInitMaxRetries) {
				this.mapInitRetryCount++;
				console.log(`检查地图就绪状态，第${this.mapInitRetryCount}次尝试`);

				setTimeout(() => {
					if (this.$refs.klmap && this.$refs.klmap.map) {
						console.log('地图已准备就绪');
						this.mapReady = true;
					} else {
						console.log('地图未就绪，继续检查');
						this.startMapCheck();
					}
				}, 200);
			} else {
				console.warn('地图初始化检查超时，强制标记为就绪');
				this.mapReady = true;
			}
		},

		// 执行待处理的项目点击
		executePendingItemClick() {
			if (this.pendingItemClick && !this.hasDefaultClicked && !this.itemClickInProgress) {
				console.log('执行待处理的项目点击');
				// 确保地图完全就绪
				setTimeout(() => {
					this.handleItemClick(this.pendingItemClick);
					this.hasDefaultClicked = true;
					this.pendingItemClick = null;
				}, 300);
			}
		},

		// 绘制待处理的轨迹数据
		drawPendingGpsData() {
			if (this.pendingGpsData && this.$refs.klmap) {
				console.log('绘制待处理的轨迹数据');
				this.GpsData = this.pendingGpsData;
				this.pendingGpsData = null;
				this.initGpsData();
			}
		},

		onMapReady() {
			console.log('地图组件触发 map-ready 事件');
			this.mapReady = true;

			// 地图就绪后，尝试触发默认点击
			setTimeout(() => {
				if (this.dataTypes && this.dataTypes.length > 0 && !this.hasDefaultClicked && !this.itemClickInProgress) {
					console.log('地图就绪后触发默认点击');
					this.tryDefaultClick();
				}
			}, 200);
		},

		handleItemClick(item) {
			if (this.loading || this.itemClickInProgress) {
				console.log('已有点击在进行中，跳过');
				return;
			}

			console.log('===== handleItemClick 开始 =====');
			console.log('当前车辆:', this.carNo, '点击的列表项:', item);

			this.loading = true;
			this.itemClickInProgress = true;

			// 记录当前点击的项目ID
			const itemId = `${item.VehicleIDs}-${item.BeginTime}-${item.EndTime}`;
			this.currentItemId = itemId;

			// 检查地图组件是否可用
			if (!this.$refs.klmap || !this.mapReady) {
				console.warn('地图组件还未加载完成，等待重新点击');
				this.loading = false;
				this.itemClickInProgress = false;
				this.pendingItemClick = item;

				// 延迟后重试
				setTimeout(() => {
					if (this.$refs.klmap && this.mapReady) {
						this.handleItemClick(item);
					} else {
						console.error('地图组件仍然不可用，取消操作');
						this.$message.warning('地图组件未准备好，请稍后重试');
					}
				}, 500);
				return;
			}

			// 在获取新数据前清除旧的轨迹
			this.clearMapTrack();

			// 重置显示数据，避免显示上一次的缓存
			this.localTraceData = [];
			this.localDrivingScore = [];
			this.localDrivingdata = { ...this.emptyDrivingData };

			// 强制重新渲染组件
			this.mileageInfoKey += 1;
			this.scoreItemListKey += 1;

			const mileage = item.Mileage;

			// 并行获取轨迹数据和评分详情
			Promise.all([
				this.getTrackData(item),
				this.getDrivingScoreDetail(item, mileage, itemId)
			]).finally(() => {
				this.loading = false;
				this.itemClickInProgress = false;
			});
		},

		// 获取轨迹数据
		getTrackData(item) {
			console.log('获取轨迹数据:', item);

			return this.$api.QueryVehicleTrackInfo({
				VehicleId: item.VehicleIDs.toString() || '',
				StartTime: item.BeginTime,
				EndTime: item.EndTime,
				Flag: 2,
				ParkDuration: 1,
				LanguageId: 1
			}).then((res) => {
				if (res.code === 200 && res.data && res.data.GpsData && res.data.GpsData.length > 0) {
					console.log('轨迹数据获取成功，条数:', res.data.GpsData.length);

					// 检查地图组件是否可用
					if (this.$refs.klmap && this.mapReady) {
						this.GpsData = res.data.GpsData;
						this.initGpsData();
					} else {
						console.log('地图组件未就绪，保存轨迹数据待后续绘制');
						this.pendingGpsData = res.data.GpsData;
					}
				} else {
					console.warn('没有轨迹数据:', res);
					// 清空轨迹数据
					this.GpsData = [];
					this.clearMapTrack();
				}
			}).catch((err) => {
				console.error('获取轨迹数据失败:', err);
				// 清空轨迹数据
				this.GpsData = [];
				this.clearMapTrack();
			});
		},

		// 获取驾驶评分详情
		getDrivingScoreDetail(item, mileage, itemId) {
			console.log('获取驾驶评分详情:', item);

			return this.$api.queryWebDrivingScoreDetail({
				OperatorID: this.operator.OperatorId.toString() || '',
				VehicleIDs: item.VehicleIDs.toString() || '',
				BeginTime: item.BeginTime,
				EndTime: item.EndTime,
			}).then(res => {
				if (res.code === 200) {
					console.log('详情接口返回成功');

					// 检查是否是当前点击的项目（防止异步请求返回顺序问题）
					if (this.currentItemId !== itemId) {
						console.log('收到过期的数据，已取消显示');
						return;
					}

					this.localTraceData = Array.isArray(res.TraceData) ? res.TraceData : [];
					this.localDrivingScore = Array.isArray(res.DrivingScore) ? res.DrivingScore : [];
					this.localDrivingdata = {
						Consume: res.Consume || 0.0,
						Duration: res.Duration || 0.0,
						Speed: res.Speed || 0.0,
						Mileage: mileage
					};

					console.log('数据已更新，里程:', mileage);
				} else {
					console.warn('详情接口返回错误:', res.message);
					// 重置数据
					this.localTraceData = [];
					this.localDrivingScore = [];
					this.localDrivingdata = {
						Consume: 0.0,
						Duration: 0.0,
						Speed: 0.0,
						Mileage: mileage
					};
				}
			}).catch(err => {
				console.error('详情接口请求失败:', err);
				// 重置数据
				this.localTraceData = [];
				this.localDrivingScore = [];
				this.localDrivingdata = {
					Consume: 0.0,
					Duration: 0.0,
					Speed: 0.0,
					Mileage: mileage
				};
			});
		},

		initGpsData() {
			if (!this.$refs.klmap) {
				console.error('地图组件未找到，延迟重试');
				// 延迟重试
				setTimeout(() => {
					if (this.$refs.klmap) {
						this.initGpsData();
					} else {
						console.error('地图组件仍然未找到，放弃绘制轨迹');
					}
				}, 200);
				return;
			}

			if (!this.$refs.klmap.map) {
				console.error('地图实例未就绪，延迟重试');
				// 延迟重试
				setTimeout(() => {
					if (this.$refs.klmap && this.$refs.klmap.map) {
						this.initGpsData();
					} else {
						console.error('地图实例仍然未就绪，放弃绘制轨迹');
					}
				}, 200);
				return;
			}

			if (!this.GpsData || this.GpsData.length === 0) {
				console.warn('轨迹数据为空，无法绘制');
				return;
			}

			// 过滤无效坐标
			var bd_gps = [];
			this.GpsData.forEach((item) => {
				// 确保坐标有效
				if (item.Longitude && item.Latitude &&
					!isNaN(parseFloat(item.Longitude)) &&
					!isNaN(parseFloat(item.Latitude)) &&
					parseFloat(item.Longitude) > 0 &&
					parseFloat(item.Latitude) > 0) {
					bd_gps.push({
						lng: parseFloat(item.Longitude),
						lat: parseFloat(item.Latitude)
					});
				}
			});

			console.log('有效的轨迹点数量:', bd_gps.length);

			if (bd_gps.length > 0) {
				console.log('绘制轨迹点');

				try {
					// 先清除所有现有轨迹
					this.clearMapTrack();

					// 添加轨迹线
					this.$refs.klmap.addPolyline("gps_line", "gps_line", bd_gps, 5, "#2A7AFF");
					console.log('轨迹绘制完成');

					// 设置地图视野到轨迹范围
					if (this.$refs.klmap.setView && bd_gps.length > 0) {
						setTimeout(() => {
							this.$refs.klmap.setView(bd_gps);
						}, 300);
					}
				} catch (error) {
					console.error('绘制轨迹失败:', error);
					// 尝试重新绘制
					setTimeout(() => {
						this.initGpsData();
					}, 300);
				}
			} else {
				console.warn('没有有效的轨迹点数据');
			}
		},

		formatTime(timeStr) {
			if (!timeStr) return '';
			return timeStr.replace('T', ' ').replace('Z', '').replace(/-/g, '/');
		},

		handleSizeChange(val) {
			this.pageSize = val;
			this.currentPage = 1; // 切换每页条数时重置为第1页
		},

		handleCurrentChange(val) {
			this.currentPage = val;
		},
		
		// 判断项目是否被选中
		isItemSelected(item) {
			if (!item || !this.currentItemId) return false;
			const itemId = `${item.VehicleIDs}-${item.BeginTime}-${item.EndTime}`;
			return this.currentItemId === itemId;
		},
	},
	mounted() {
		console.log('组件 mounted，开始初始化');

		// 记录初始车辆号
		this.previousCarNo = this.carNo;

		// 标记第一次加载
		this.firstLoad = true;

		// 启动地图检查
		this.startMapCheck();
	},

	beforeDestroy() {
		// 清理地图覆盖物
		this.clearMapTrack();
	}
}
</script>
<style lang="scss" scoped>
::v-deep .el-pagination {
	width: 100% !important;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	/* 页码区域右对齐 */
}

/* 调整分页元素间距，避免拥挤 */
::v-deep .el-pagination__sizes {
	margin-right: 16px !important;
}

::v-deep .el-pagination__pager {
	margin: 0 !important;
	/* 清除默认margin，避免溢出 */
}

::v-deep .el-pagination__button {
	min-width: 28px !important;
	/* 缩小页码按钮宽度 */
	height: 28px !important;
	line-height: 28px !important;
}

@media (max-width: 768px) {
	::v-deep .el-pagination__total {
		display: none;
	}
}

.pagination-wrapper {
	overflow-x: auto;
	display: flex;
	align-items: center;
	padding: 12px 0;
}
</style>